import { useState } from "react";
import Modal from "../Modal/Modal";
import Tabs from "../../modules/AIHumans/components/Tabs";
import PopupHeader from "./components/PopupHeader";
import styled from "styled-components";
import { FullScreenPopupContentWrapper, FullScreenPopupTitle } from "./popups.styles";
import { GuideTabProps, guideTabs, DosAndDontsInstructionData } from "../../mocks/customAvatar";
import Button from "../Button/Button";
// import { useDispatch } from "react-redux";
// import { Popups, updatePopup } from "../../redux/actions/popupsActions";
// import { useSelector } from "react-redux";
// import { getPrefilled } from "../../redux/reducers/popupsReducer";
import useCustomAvatarPopupSteps from "../../hooks/useCustomAvatarPopupSteps";

interface Props {
  open: boolean;
  onClose: () => void;
}

const PrepareRecordingEnvironmentPopup = ({ open, onClose }: Props) => {
  const [activeTab, setActiveTab] = useState(GuideTabProps.TEXT_INSTRUCTIONS_TAB);
  const { goToFirstStep, openInstantImageUploaderPopup } = useCustomAvatarPopupSteps(onClose);

  const handleActiveTab = (tab: string) => {
    setActiveTab(tab as GuideTabProps);
  };

  const content = {
    [GuideTabProps.TEXT_INSTRUCTIONS_TAB]: (
      <TextInstructionsWrapper>
        {DosAndDontsInstructionData.map(({ heading, headingIcon, listPoints }, index) => (
          <GridBox key={heading} index={index}>
            <FlexWrapper>
              {headingIcon}
              <Heading>{heading}</Heading>
            </FlexWrapper>
            <PointsWrapper>
              {listPoints.map(({ icon, text }) => (
                <FlexWrapper key={text}>
                  <IconWrapper>{icon}</IconWrapper>
                  <Text>{text}</Text>
                </FlexWrapper>
              ))}
            </PointsWrapper>
          </GridBox>
        ))}
      </TextInstructionsWrapper>
    ),
    [GuideTabProps.VIDEO_INSTRUCTIONS_TAB]: (
      <VideoInstructionsWrapper>
        <Video
          src="https://www.w3schools.com/html/mov_bbb.mp4" // in-progress
          autoPlay
        />
      </VideoInstructionsWrapper>
    ),
  };
  return (
    <Modal className="prepareRecordingEnvironmentPopup" open={open} onClose={onClose} closeIcon={false}>
      <PopupHeader
        menuButtonAction={onClose}
        handlePreviousButton={goToFirstStep}
        handleNextButton={openInstantImageUploaderPopup}
      />
      <FullScreenPopupContentWrapper>
        <FullScreenPopupTitle>Prepare your recording environment</FullScreenPopupTitle>
        <TabsWrapper>
          <Tabs data={guideTabs} active={activeTab} disabled={false} handleActive={handleActiveTab} />
        </TabsWrapper>
        <Content>{content[activeTab]}</Content>
        <ButtonWrapper>
          <Button text="I Understand" onClick={openInstantImageUploaderPopup} />
        </ButtonWrapper>
      </FullScreenPopupContentWrapper>
    </Modal>
  );
};

const TabsWrapper = styled.div`
  width: 100%;
  max-width: 250px;
  margin-inline: auto;
  > div {
    min-height: 38px;
    & button {
      box-shadow: none;
      padding-inline: 12px;
      & > span {
        font-size: 12px;
      }
    }
  }
`;
const Content = styled.div`
  min-height: 310px;
`;
const ButtonWrapper = styled.div`
  width: 100%;
  max-width: 218px;
  & button {
    height: 34px;
    box-shadow: none;
    border-radius: 5px;
    span {
      font-size: 14px;
    }
  }
`;
const TextInstructionsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 487px));
  column-gap: 48px;
  row-gap: 32px;
  border-radius: 8px;
  color: #fff;
  justify-content: center;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const GridBox = styled.div<{ index: number }>`
  border: 1px solid #212121;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
  /* gap: ${({ index }) => (index === 0 ? "52px" : "24px")}; */
`;

const Heading = styled.span`
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
`;
const PointsWrapper = styled.div`
  display: grid;
  gap: 8px;
`;
const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
const IconWrapper = styled.span`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Text = styled.span`
  font-size: 16px;
  font-weight: 500;
`;

const VideoInstructionsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 335px;
  width: 559px;
  margin: 0 auto;
`;

const Video = styled.video`
  width: 100%;
  max-height: 100%;
  /* border-radius: 8px; */
`;

export default PrepareRecordingEnvironmentPopup;
